import React from 'react';
import { App } from '@gin-betting/core';
import cn from 'classnames';

import { CompareStatus } from 'app-constants';
import { Icon } from 'components';
import { useCompare } from 'hooks';
import { formatDecimalOdd } from 'utils';

import arrow from 'assets/svg/arrow.svg';
import './oddValue.scss';

interface Props {
    value: number;
    oddFormat: App.OddFormat;
}

const OddValue: React.FC<Props> = ({ value, oddFormat }) => {
    const { compareStatus } = useCompare({ value });
    const { component } = formatDecimalOdd(value, oddFormat);

    const isStatic = compareStatus === CompareStatus.Equal;
    const isIncreased = compareStatus === CompareStatus.Greater;
    const isDecreased = compareStatus === CompareStatus.Smaller;

    return (
        <div
            styleName={cn('container', {
                increased: isIncreased,
                decreased: isDecreased,
            })}
            className="__app-OddValue-container"
        >
            {component}
            {!isStatic && <Icon glyph={arrow} styleName="arrow" />}
        </div>
    );
};

export default OddValue;
